import { Component, ViewChild, OnInit } from '@angular/core';
import {NavController, NavParams, AlertController, LoadingController} from 'ionic-angular';
import { DataProvider } from '../../providers/data';
import { Store } from '../../models/store';
import { } from '@types/googlemaps';
import { Geolocation, GeolocationOptions } from '@ionic-native/geolocation';
import {TranslateService} from '@ngx-translate/core';

/**
 * Generated class for the BootsMapPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
declare var MarkerClusterer: any;

@Component({
  selector: 'page-boots-map',
  templateUrl: 'boots-map.html',
})
export class BootsMapPage {
  public wholeCountryLatitude: number;
  public wholeCountryLongitude: number;
  public wholeCountryZoom: number = 15;

  public curCountry: string;

  // public latitude: number;
  // public longitude: number;
  // public zoom: number;
  public userPosition: google.maps.LatLng;
  public userMarker: google.maps.Marker;

  public stores: Store[] = [];

  private centerMap = null;
  private noPharmacyMessage = '';

  @ViewChild('gmap') gmapElement: any;
  public map: google.maps.Map;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private dataService: DataProvider,
              public loadingController: LoadingController,
              public geolocation: Geolocation,
              public alertCtrl: AlertController,
              private translate: TranslateService) {
    //this.showWholeCountry();
    this.wholeCountryLatitude = dataService.COUNTRY_LAT;
    this.wholeCountryLongitude = dataService.COUNTRY_LNG;
    this.curCountry = dataService.CURRENT_COUNTRY;
    this.centerMap = {
      lat: this.wholeCountryLatitude,
      lng: this.wholeCountryLongitude
    };

    this.translate.get('MAP_NO_PHARMACIES_FOUND').subscribe(
        translation => {
          this.noPharmacyMessage = translation;
        })
  }

  ionViewDidLoad() {
    this.getLocation();
  }

  // public showWholeCountry() {
  //   this.latitude = this.wholeCountryLatitude;
  //   this.longitude = this.wholeCountryLongitude;
  //   this.zoom = this.wholeCountryZoom;
  // }

  public goToMyLocation() {
    if (this.userPosition) {
      this.map.setCenter(this.userPosition);
      this.map.setZoom(15);
    }
    // else {
    //   let alert = this.alertCtrl.create({
    //     title: 'Error',
    //     message: 'Unable to show you location.',
    //     buttons: [
    //       {
    //         text: 'OK',
    //         handler: () => { }
    //       }
    //     ]
    //   });
    //   alert.present();
    // }


    //let this1 = this;
    // this.geolocation.getCurrentPosition(<GeolocationOptions>{ enableHighAccuracy: true }).then((position) => {
    //   this1.map.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
    //   this1.map.setZoom(13);
    // }).catch((error) => {
    //   console.log('Error getting location', error);
    // });
  }

  private getLocation() {
    this.geolocation.getCurrentPosition().then((resp) => {
      console.log("Detected coords: ", resp.coords);
      this.centerMap = {
        lat: resp.coords.latitude,
        lng: resp.coords.longitude
      };

      this.createMap();
    }).catch((error) => {
      console.log('Error getting location', error);
      this.createMap();
    });
  }

  private createMap() {
    const loading = this.loadingController.create();

    loading.present();

    let mapProps = {
      center: new google.maps.LatLng(this.centerMap['lat'], this.centerMap['lng']),
      zoom: this.wholeCountryZoom,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      fullscreenControl: false,
      streetViewControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP
      },
    };
    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProps);

    this.dataService.getStores(this.centerMap['lat'], this.centerMap['lng']).subscribe((res) => {

      loading.dismissAll();

      let storesData = res['stores'];

      if (storesData.length) {
        let infowindow = new google.maps.InfoWindow();
        let markers: google.maps.Marker[] = [];

        for (let store of storesData) {
          if (!store.lat || !store.lng || markers.some(m => m['lat'] === store.lat && m['lng'] === store.lng)) continue;

          let marker = new google.maps.Marker({
            position: {lat: store.lat, lng: store.lng},
            title: store.company
          });
          marker['lat'] = store.lat;
          marker['lng'] = store.lng;
          marker.addListener('click', () => {
            let contentStr = `<h4>${store.company}</h4>
      <div class="info-window-content">
      <ion-scroll scrollY="true">    
        <div>`;
            if (store.city) {
              contentStr += `<dl class="store_info_list">
            <dt class="store_info_list_label">Address</dt>
            <dd class="store_info_list_item">${store.city}`;
              if (store.street) {
                contentStr += `, ${store.street}`;
              }
              if (store.street2) {
                contentStr += `, ${store.street2}`;
              }
              if (store.postcode) {
                contentStr += `, ${store.postcode}`;
              }
              contentStr += `</dd></dl>`;
            }
            if (store.phone && store.phone !== '') {
              contentStr += `<dl class="store_info_list">
            <dt class="store_info_list_label">Contact number</dt>
            <dd class="store_info_list_item">
              <a class="store_manager_tel_cta" href="tel:${store.phone}">${store.phone}</a>
            </dd>
          </dl>`;
            }
            contentStr += `</div>
          <div>`;
            contentStr += `</div>
                        </ion-scroll>
                        </div>`;
            infowindow.setContent(contentStr);
            infowindow.open(this.map, marker);
          });

          markers.push(marker);
        }

        let markerCluster = new MarkerClusterer(this.map, markers,
            {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m' });
      } else {
        const alert = this.alertCtrl.create({
          message: this.noPharmacyMessage,
          buttons: [
            {
              text: 'OK',
              role: 'cancel'
            }
          ],
          cssClass: 'alert-danger'
        });

        alert.present();
      }
    });



    console.log('ionViewDidLoad BootsMapPage');
    //let this1 = this;
    // if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition(function (position) {
    //     this1.latitude = position.coords.latitude;
    //     this1.longitude = position.coords.longitude;
    //     this1.zoom = 12;
    //   }, function () {
    //     this1.showWholeCountry();
    //   });
    // } else {
    //  this1.showWholeCountry();
    //}

    let watch = this.geolocation.watchPosition(<GeolocationOptions>{ enableHighAccuracy: true });
    watch.subscribe((data) => {
      if (data && data.coords) {
        this.userPosition = new google.maps.LatLng(data.coords.latitude, data.coords.longitude);
        if (!this.userMarker) {
          this.userMarker = new google.maps.Marker({
            position: this.userPosition,
            map: this.map,
            icon: 'assets/' + this.curCountry + '/images/icons/bluecircle.png'
          });
        }
        else {
          this.userMarker.setPosition(this.userPosition);
        }
      }
      // data can be a set of coordinates, or an error (if an error occurred).
      // data.coords.latitude
      // data.coords.longitude
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/boots-map/boots-map.ts